import React, { useState, Fragment } from "react";

// Libraries
import { connect } from "react-redux";

// Core
import { createMeta } from "../../../core/session";
import Select from "react-select";

// Components
import Navigation from "../../components/navigation";
import Button from "../../components/buttons";
import { companies } from "./config";

const Form = ({ createMeta }) => {
    const [street, setStreet] = useState("");
    const [company, setCompany] = useState(null);
    const [avg, setAvg] = useState(false);

    const submitForm = () => {
        createMeta({
            company,
            street,
            avg,
        });
    };

    return (
        <Fragment>
            <Navigation />
            <div className="flex flex-center">
                <div className="pt-l pb-l container container-m center relative">
                    <h3 className="pt-l fs-m a-l mb">
                        Aan welke straat woont u?
                    </h3>
                    <input
                        className="input"
                        placeholder="Type een straatnaam"
                        onChange={({ target }) => setStreet(target.value)}
                    />
                    <h3 className="fs-m a-l mb mt">
                        Wat voor onderneming hebt u?
                    </h3>
                    <Select
                        options={companies}
                        blurInputOnSelect={true}
                        isSearchable={false}
                        onChange={({ value }) => setCompany(value)}
                    />

                    <div className="flex flex-align mt-m">
                        <input
                            type="checkbox"
                            className="checkbox mr"
                            id="AVG"
                            name="AVG"
                            value={avg}
                            onChange={() => setAvg(!avg)}
                        ></input>
                        <label className="a-l" htmlFor="AVG">
                            Ik ga akkoord met de onderstaande voorwaarden
                        </label>
                    </div>
                    <div className="mt fs-xxs leading-tight a-l">
                        Ik geef toestemming voor het verwerken van de hiervoor
                        vermelde gegevens voor het uitvoeren en het maken van
                        een buurtagenda ten behoeve van de vitaliteitsagenda. Uw
                        gegevens zullen niet gebruikt worden voor andere
                        doeleinden. De gegevens worden vertrouwelijk gebruikt in
                        overeenstemming met de privacyverklaring van Eurus.
                    </div>
                    <Button
                        text={"Volgende"}
                        className="full mt-m mb-m"
                        disabled={!avg}
                        onClick={submitForm}
                    />
                </div>
            </div>
        </Fragment>
    );
};

export default connect(null, { createMeta })(Form);
